import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ChoosePlanStyle.css";

import PaymentsDetails from "../UserPlan/PaymentsDetails";
import FreePlanConfirmModal from "./FreePlanConfirmModal";
import { New_ScrollX2025 } from "../../assets/icons";

import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Redux/actions/authActions";
import { getProjects } from "../../Redux/actions/projectsActions";
import {
  getCurrentPlan,
  getRendersPlan,
  getUserAllInformation,
  PlanHandler,
  updateUserCardInfo,
} from "../../Redux/actions/commonActtion";

import { toast } from "react-toastify";
import CustomToast, {
  defaultcustomToatStyle,
} from "../../Components/CustomToast/CustomToast";
import { Loader2 } from "../../Components";

const FAQ_DATA = [
  {
    q: "How many projects can I create on each plan?",
    a: "Each plan varies in the number of active titles you can work on simultaneously. Check the plan features for details on project limits.",
  },
  {
    q: "Can I switch plans later?",
    a: "Yes. You can upgrade or downgrade at any time from your account settings. Changes take effect on your next billing cycle.",
  },
  {
    q: "What happens to my project if I cancel?",
    a: "Your project stays saved. If you resubscribe later, everything — your credits, templates, and settings — will be exactly where you left them.",
  },
  {
    q: "Is there a limit on renders or exports?",
    a: "No. Every plan includes unlimited renders and exports at the quality level specified in your plan.",
  },
];


const OnSubscriptionPlanList = ({
  setRenderOpen,
  isPlanShow,
  setIsPlanShow,
}) => {
  const location = useLocation();
  const { isDashboard, projectId, isCard, pathSegment, isMoreInfo, isRender } =
    location.state || {};

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));

  const [currentPlanRange, setCurrentPlanRange] = useState({
    start: 0,
    end: 2,
  });
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [isFreePlanModalOpen, setIsFreePlanModalOpen] = useState(false);
  const [pendingFreePlan, setPendingFreePlan] = useState(null);

  // New state for the redesigned UI
  const [selectedPlanForCheckout, setSelectedPlanForCheckout] = useState(null);
  const [openFaqIndex, setOpenFaqIndex] = useState(-1);
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const faqRefs = useRef([]);
  const dropdownRef = useRef(null);
  const profileBtnRef = useRef(null);

  const { renderPlan, userData } = useSelector((state) => state.commonReducer);
  const commonReducer = useSelector((state) => state?.commonReducer);
  const currentPlan = commonReducer?.currentPlan;
  const subscription_status =
    commonReducer?.currentPlan?.plan?.subscription_status;
  const isExpired = commonReducer?.currentPlan?.isExpired;
  const currentPlanDetails = currentPlan?.plan?.plan_detail;
  const [isUserPaid, setIsUserPaid] = useState(
    currentPlan.success && currentPlan.plan ? true : false,
  );

  // ✅ Check if user has card added
  const isCardAdded = userData?.[0]?.isCardAdded;

  useEffect(() => {
    const fetchInitialData = async () => {
      setIsDataLoading(true);
      try {
        await dispatch(getCurrentPlan());
        await dispatch(getUserAllInformation());
        await getRenderPlanDetails();
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setIsDataLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    getRenderPlanDetails();
  }, [isSuccessOpen]);

  // Auto-select the first paid plan when renderPlan loads
  useEffect(() => {
    if (renderPlan && renderPlan.length > 0 && !selectedPlanForCheckout) {
      const paidPlans = renderPlan.filter((p) => p.price > 0);
      if (paidPlans.length > 0) {
        // Try to select the middle plan (most popular), else first
        const midIndex = Math.min(1, paidPlans.length - 1);
        setSelectedPlanForCheckout(paidPlans[midIndex]);
      }
    }
  }, [renderPlan]);

  const getRenderPlanDetails = async () => {
    await dispatch(getRendersPlan(user));
    await dispatch(getCurrentPlan());
  };

  const getTrackingCurrency = (currency) => {
    if (typeof currency === "string" && /^[a-z]{3}$/i.test(currency)) {
      return currency.toUpperCase();
    }

    return "USD";
  };

  const pushSubscriptionStartedEvent = (plan, session) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "begin_checkout",
      subscription_status: "in_progress",
      transaction_id: session?.id,
      value: Number(plan?.price || 0),
      currency: getTrackingCurrency(plan?.currency),
      items: [
        {
          item_id: plan?._id,
          item_name: `${plan?.type || "Subscription"} Plan`,
          price: Number(plan?.price || 0),
          quantity: 1,
        },
      ],
    });
  };

  // Navigate to embedded checkout page
  const handlePlanUpgrade = async (plan) => {
    if (plan.price === 0) {
      toast(
        <CustomToast title="" content="You're already on the free plan" />,
        defaultcustomToatStyle,
      );
      return;
    }

    navigate("/checkout", { state: { plan } });
  };

  // Update your existing click handler
  const handlePlanClick = async (plan) => {
    if (plan.price === 0) {
      // Show confirmation modal for free plan
      setPendingFreePlan(plan);
      setIsFreePlanModalOpen(true);
    } else if (!isExpired) {
      handleUpgradeOnSubscriptionActive(plan);
    } else {
      await handlePlanUpgrade(plan);
    }
  };

  useEffect(() => {
    const isExpired = commonReducer?.currentPlan?.isExpired;
    if (!isDataLoading && isCardAdded && !isExpired) {
      navigate("/dashboard");
    }
  }, [isDataLoading, isCardAdded, commonReducer?.currentPlan?.isExpired, navigate]);

  // Close the setting dropdown if the user scrolls or clicks outside
  useEffect(() => {
    const handleScroll = () => {
      if (isSettingOpen) {
        setIsSettingOpen(false);
      }
    };

    const handleClickOutside = (event) => {
      if (
        isSettingOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        profileBtnRef.current &&
        !profileBtnRef.current.contains(event.target)
      ) {
        setIsSettingOpen(false);
      }
    };

    if (isSettingOpen) {
      window.addEventListener("scroll", handleScroll, true);
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSettingOpen]);

  const createdAt = new Date(currentPlan?.plan?.createdAt);
  const planPurchaseDate = isNaN(createdAt.valueOf())
    ? ""
    : `${createdAt?.getDate()}/${
        createdAt?.getMonth() + 1
      }/${createdAt?.getFullYear()}`;

  const validityValue = parseInt(currentPlanDetails?.validity, 10) || 0;
  const [remainingDays, setRemainingDays] = useState("");
  const [remainingHours, setRemainingHours] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const today = new Date();
  const planRenewDate = new Date(
    createdAt?.getTime() + validityValue * 24 * 60 * 60 * 1000,
  );
  let timeDifference = planRenewDate - today;

  useEffect(() => {
    let prevRemainingDays = remainingDays;

    if (remainingDays === 1 || validityValue === 1) {
      const interval = setInterval(() => getTime(prevRemainingDays), 1000);
      return () => clearInterval(interval);
    } else {
      getTime(prevRemainingDays);
    }
  }, [remainingDays, validityValue, timeDifference]);

  const getTime = async (prevRemainingDays) => {
    if (!isNaN(validityValue)) {
      if (timeDifference > 0) {
        if (timeDifference >= 24 * 60 * 60 * 1000) {
          const updatedRemainingDays = Math.ceil(
            timeDifference / (24 * 60 * 60 * 1000),
          );
          timeDifference -= updatedRemainingDays * 24 * 60 * 60 * 1000;

          if (prevRemainingDays === 1 && updatedRemainingDays === 0) {
            setRemainingHours(0);
            setRemainingMinutes(0);
            setRemainingSeconds(0);
            setIsUserPaid(false);
          }
          setRemainingDays(updatedRemainingDays);
        }
        if (timeDifference >= 60 * 60 * 1000) {
          setRemainingHours(Math.floor(timeDifference / (60 * 60 * 1000)));
          timeDifference -= remainingHours * 60 * 60 * 1000;
        }

        if (timeDifference >= 60 * 1000) {
          setRemainingMinutes(Math.floor(timeDifference / (60 * 1000)));
          timeDifference -= remainingMinutes * 60 * 1000;
        }

        setRemainingSeconds(Math.floor(timeDifference / 1000));
      } else if (remainingDays === 0) {
        setIsUserPaid(false);
      } else {
        setRemainingDays(0);
        setRemainingHours(0);
        setRemainingMinutes(0);
        setRemainingSeconds(0);
      }
    }
  };

  const expirationMessage =
    remainingDays === 1 || validityValue === 1
      ? `Plan Expires in ${remainingHours}:${remainingMinutes}:${remainingSeconds}`
      : remainingDays > 1
        ? `Remaining days ${remainingDays}`
        : Object.keys(currentPlan).length === 0
          ? "Buy New Plan"
          : "Plan Expired ";

  const goToNextPlan = () => {
    if (currentPlanRange.end < renderPlan.length - 1) {
      setCurrentPlanRange({
        start: currentPlanRange.start + 1,
        end: currentPlanRange.end + 1,
      });
    }
  };

  const goToPreviousPlan = () => {
    if (currentPlanRange.start > 0) {
      setCurrentPlanRange({
        start: currentPlanRange.start - 1,
        end: currentPlanRange.end - 1,
      });
    }
  };

  const isEmptyObject =
    currentPlan &&
    Object.keys(currentPlan).length === 0 &&
    currentPlan.constructor === Object;

  const handleUpgradeOnSubscriptionActive = (plan) => {
    if (
      plan?._id !== currentPlan?.plan?.plan_detail?._id &&
      plan?.price !== 0
    ) {
      toast(
        <CustomToast
          title=""
          content={
            "You're already subscribed, Please cancel your current plan first and then upgrade your plan"
          }
        />,
        defaultcustomToatStyle,
      );
    }
  };

  // Handle free plan confirmation
  const handleFreePlanConfirm = async () => {
    try {
      await dispatch(updateUserCardInfo());
      setIsFreePlanModalOpen(false);
      setPendingFreePlan(null);
      navigate("/dashboard");
    } catch (error) {
      toast(
        <CustomToast
          title="Error"
          content="Something went wrong. Please try again."
        />,
        defaultcustomToatStyle,
      );
    }
  };

  // Handle free plan cancel
  const handleFreePlanCancel = () => {
    setIsFreePlanModalOpen(false);
    setPendingFreePlan(null);
  };

  // Select a plan card (visual selection)
  const handleSelectPlanCard = (plan) => {
    if (plan.price === 0) return;
    // Don't allow selecting if current plan is active
    if (currentPlanDetails?._id === plan._id && !isExpired) return;
    setSelectedPlanForCheckout(plan);
  };

  // Continue button handler
  const handleContinue = () => {
    if (!selectedPlanForCheckout) return;
    handlePlanClick(selectedPlanForCheckout);
  };

  // FAQ toggle
  const toggleFaq = (index) => {
    if (openFaqIndex === index) {
      setOpenFaqIndex(-1);
    } else {
      setOpenFaqIndex(index);
    }
  };

  // Get features array for a plan
  const getPlanFeatures = (plan) => {
    return [plan.text1, plan.text2, plan.text3, plan.text4, plan.text6].filter(Boolean);
  };

  // Check if a plan is the currently active one
  const isCurrentActivePlan = (plan) => {
    return currentPlanDetails?._id === plan._id && !isExpired;
  };

  // Get paid plans only
  const paidPlans = renderPlan
    ? renderPlan.filter((p) => p.price > 0)
    : [];

  // ✅ Show loading screen while fetching user data
  if (isDataLoading) {
    return (
      <div className="cp-loading">
        <div className="text-center">
          <Loader2 />
        </div>
      </div>
    );
  }

  return (
    <>
      {isPlanShow || (
        <div className="cp-page">
          <div className="cp-particles" />

          {/* ── Topbar ── */}
          <header className="cp-topbar">
            <div className="cp-logo">
              <a href="https://scrollx.io/"  className="nav-logo">
               <img className="w-[35px]" src={New_ScrollX2025} alt="ScrollX" />
              <span style={{ marginLeft: "6px", fontSize: "18px", fontWeight: "700" }}>ScrollX.io</span>
              </a>             
            </div>
            <div className="cp-topbar-right">
              <div className="cp-topbar-meta">
                Signed in as <strong>{user?.email || "user"}</strong>
              </div>
              <button
                ref={profileBtnRef}
                className="cp-profile-btn"
                onClick={() => setIsSettingOpen(!isSettingOpen)}
              >
                {(user?.firstName?.charAt(0) || "U").toUpperCase()}
              </button>
            </div>
          </header>

          {/* ── Step progress ── */}
          <div className="cp-steps-bar">
            <div className="cp-step done">
              <div className="cp-step-num">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <path d="M5 12l5 5L20 7" />
                </svg>
              </div>
              <span className="cp-step-label">Account</span>
            </div>
            <div className="cp-step-connector" />
            <div className="cp-step activee">
              <div className="cp-step-num">2</div>
              <span className="cp-step-label">Choose plan</span>
            </div>
            <div className="cp-step-connector" />
            <div className="cp-step upcoming">
              <div className="cp-step-num">3</div>
              <span className="cp-step-label">Payment</span>
            </div>
          </div>

          {/* ── Main Content ── */}
          <div className="cp-main">
            {/* Header */}
            <div className="cp-page-header">
              <p className="cp-page-eyebrow">Step 2 of 3</p>
              <h1 className="cp-page-h1">
                Start building. <em>Cancel anytime.</em>
              </h1>
              <p className="cp-page-sub">
                Pick a plan and start for $0 today.
              </p>
            </div>

            {/* Trial pill */}
            <div style={{ textAlign: "center" }}>
              <div className="cp-trial-pill">
                <div className="cp-trial-dot" />
                <strong>3-day free trial</strong> on every plan. No charge until day 4.
              </div>
            </div>

            {/* ── Plan Cards ── */}
            <div className="cp-plans" style={{
              gridTemplateColumns: paidPlans.length === 1
                ? "minmax(0, calc((100% - 28px) / 3))"
                : paidPlans.length === 2
                  ? "repeat(2, minmax(0, calc((100% - 28px) / 3)))"
                  : "repeat(3, 1fr)",
              justifyContent: "center",
            }}>
              {paidPlans.map((plan) => {
                const isSelected = selectedPlanForCheckout?._id === plan._id;
                const isCurrent = isCurrentActivePlan(plan);
                const isFeatured = Number(plan.price) === 89;

                return (
                  <div
                    className={`cp-plan${isSelected ? " cp-selected" : ""}${isFeatured ? " cp-featured" : ""}${isCurrent ? " cp-current-active" : ""}${isLoading ? " opacity-50 pointer-events-none" : ""}`}
                    key={plan._id}
                    onClick={() => handleSelectPlanCard(plan)}
                  >
                    {/* Check ring */}
                    <div className="cp-plan-check-ring">
                      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5" strokeLinecap="round">
                        <path d="M5 12l5 5L20 7" />
                      </svg>
                    </div>

                    {/* Badge */}
                    <span className={`cp-plan-badge ${isFeatured ? "cp-badge-violet" : "cp-badge-dim"}`}>
                      {plan.tag || plan.type}
                    </span>

                    {/* Name */}
                    <div className="cp-plan-name">{plan.type}</div>

                    {/* Description */}
                    <div className="cp-plan-desc">
                      {plan.text5 || plan.teams || `${plan.type} plan`}
                    </div>

                    {/* Price */}
                    <div className="cp-plan-price-wrap">
                      <span className="cp-plan-price">
                        {plan.currency}{plan.price}
                      </span>
                      <span className="cp-plan-period">
                        / {plan.interval_validity}
                      </span>
                    </div>
                    <div className="cp-plan-billing">
                      billed {plan.interval_validity} after trial
                    </div>

                    {/* Divider */}
                    <div className="cp-plan-hr" />

                    {/* Features */}
                    <ul className="cp-plan-features">
                      {getPlanFeatures(plan).map((feature, fi) => (
                        <li key={fi}>{feature}</li>
                      ))}
                    </ul>

                    {/* Current plan indicator */}
                    {isCurrent && (
                      <div style={{
                        marginTop: "16px",
                        padding: "6px 12px",
                        borderRadius: "8px",
                        background: "rgba(124,92,255,.15)",
                        border: "1px solid rgba(124,92,255,.3)",
                        textAlign: "center",
                        fontSize: "12px",
                        fontWeight: 600,
                        color: "#c4b2ff",
                      }}>
                        Current Plan
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {/* ── Continue CTA ── */}
            <div className="cp-continue-wrap">
              <button
                className="cp-continue-btn"
                onClick={handleContinue}
                disabled={!selectedPlanForCheckout || isLoading}
              >
                Continue with {selectedPlanForCheckout?.type || "Plan"}
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
              <div className="cp-continue-sub">
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
                Start for $0 today. Cancel anytime before day 4.
              </div>
            </div>

            {/* ── Trial Timeline ── */}
            <div className="cp-timeline-section">
              <div className="cp-timeline-header">
                <p className="cp-timeline-eyebrow">Your trial, mapped out</p>
                <div className="cp-timeline-title">
                  No surprises. <em>Ever.</em>
                </div>
              </div>
              <div className="cp-timeline-wrap">
                <div className="cp-timeline-line" />
                <div className="cp-timeline-track">
                  <div className="cp-timeline-point">
                    <div className="cp-timeline-dot cp-dot-green">
                      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12l5 5L20 7" />
                      </svg>
                    </div>
                    <div className="cp-timeline-day cp-day-green">Today</div>
                    <div className="cp-timeline-label">Create end credits for free</div>
                    <div className="cp-timeline-desc">Full access to your plan. No charge yet.</div>
                  </div>
                  <div className="cp-timeline-point">
                    <div className="cp-timeline-dot cp-dot-amber">
                      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="9" />
                      </svg>
                    </div>
                    <div className="cp-timeline-day cp-day-amber">Day 3</div>
                    <div className="cp-timeline-label">Cancel for free, if you want</div>
                    <div className="cp-timeline-desc">One click, no charge, no questions asked.</div>
                  </div>
                  <div className="cp-timeline-point">
                    <div className="cp-timeline-dot cp-dot-violet">
                      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="1" y="4" width="22" height="16" rx="2" />
                        <line x1="1" y1="10" x2="23" y2="10" />
                      </svg>
                    </div>
                    <div className="cp-timeline-day cp-day-violet">Day 4</div>
                    <div className="cp-timeline-label">Your card is charged</div>
                    <div className="cp-timeline-desc">First billing period begins automatically.</div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── FAQ ── */}
            <div className="cp-faq-section">
              <div className="cp-faq-section-header">
                <p className="cp-faq-section-eyebrow">Questions about plans</p>
                <div className="cp-faq-section-title">
                  Quick <em>answers.</em>
                </div>
              </div>
              <div className="cp-faq-list">
                {FAQ_DATA.map((faq, i) => (
                  <div
                    className={`cp-faq-item${openFaqIndex === i ? " cp-open" : ""}`}
                    key={i}
                  >
                    <button className="cp-faq-q" onClick={() => toggleFaq(i)}>
                      {faq.q}
                      <span className="cp-faq-q-plus">+</span>
                    </button>
                    <div
                      className="cp-faq-a"
                      ref={(el) => (faqRefs.current[i] = el)}
                      style={
                        openFaqIndex === i && faqRefs.current[i]
                          ? { maxHeight: faqRefs.current[i].scrollHeight + "px" }
                          : { maxHeight: 0 }
                      }
                    >
                      {faq.a}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ── Trust Row ── */}
            <div className="cp-trust-row">
              <div className="cp-trust-item">
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                Used on 200+ films
              </div>
              <div className="cp-trust-div" />
              <div className="cp-trust-item">
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                Fast first drafts, no design skills needed
              </div>
              <div className="cp-trust-div" />
              <div className="cp-trust-item">
                <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                Cancel anytime, no questions
              </div>
            </div>
          </div>

          {/* ── Existing overlays (preserved) ── */}
          {isOpen && (
            <PaymentsDetails
              setRenderOpen={setRenderOpen}
              isPlanShow={isPlanShow}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              selectedPlan={selectedPlan}
              currentPlanDetails={currentPlanDetails}
              paymentType={currentPlan?.plan?.payment_type}
              order_id={currentPlan?.plan?.order_id}
              subscription_status={currentPlan?.plan?.subscription_status}
              planPurchaseDate={planPurchaseDate}
              getTime={getTime}
              remainingDays={remainingDays}
              expirationMessage={expirationMessage}
              setIsSuccessOpen={setIsSuccessOpen}
            />
          )}

          {/* Settings / Profile Dropdown */}
          {isSettingOpen && (
            <div className="cp-profile-dropdown" ref={dropdownRef}>
              <div className="cp-dropdown-header">
                  <div className="cp-dropdown-avatar">
                    {(user?.firstName?.charAt(0) || "U").toUpperCase()}
                  </div>
                  <div className="cp-dropdown-user">
                    <div className="cp-dropdown-name">{user?.firstName} {user?.lastName}</div>
                    <div className="cp-dropdown-email">{user?.email}</div>
                  </div>
                </div>
                <div className="cp-dropdown-divider" />
                <div className="cp-dropdown-body">
                  <button className="cp-dropdown-item" onClick={() => { setIsSettingOpen(false); navigate("/account-settings"); }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    My Account
                  </button>
                  <button className="cp-dropdown-item" onClick={() => { setIsSettingOpen(false); navigate("/more_info", { state: {isDashboard: true} }); }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>
                    Billing Info
                  </button>
                  <button className="cp-dropdown-item" onClick={() => { setIsSettingOpen(false); window.open("/help"); }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                    Help Desk
                  </button>
                  <a href="https://www.scrollx.io/contact" target="_blank" rel="noopener noreferrer" className="cp-dropdown-item" onClick={() => setIsSettingOpen(false)}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                    Contact us
                  </a>
                </div>
                <div className="cp-dropdown-divider" />
                <div className="cp-dropdown-footer">
                  <button className="cp-dropdown-item cp-danger" onClick={() => {
                    setIsSettingOpen(false);
                    dispatch(logout(() => navigate("/")));
                    dispatch(getProjects("logout"));
                  }}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                    Log out
                  </button>
                </div>
              </div>
          )}

          {/* Free Plan Confirmation Modal */}
          <FreePlanConfirmModal
            isOpen={isFreePlanModalOpen}
            onConfirm={handleFreePlanConfirm}
            onCancel={handleFreePlanCancel}
            planName={pendingFreePlan?.type || "Free"}
          />
        </div>
      )}
    </>
  );
};

export default OnSubscriptionPlanList;
